export { default as OrgIcon } from './org.svg'
export { default as TiDBIcon } from './tidb-logo.svg'
export { default as EmptyBoxIcon } from './empty-box.svg'
export { default as TimeIcon } from './time.svg'
export { default as DMIcon } from './dm-logo.svg'
export { default as SwitchOrgIcon } from './switch-org.svg'
export { default as GiftIcon } from './gift.svg'
export { default as ClinicIcon } from './clinic-logo.svg'
export { default as DedicatedIcon } from './dedicated-icon.svg'
export { default as ServerlessIcon } from './serverless-icon.svg'
